module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "bw1dy3x1",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
  backend: process.env.GATSBY_BACKEND || "http://localhost:3000/",
};
